import { useState, useEffect } from 'react';
import { Box, Flex, Image, Portal } from "@chakra-ui/react";
import { FaRegImages } from "react-icons/fa";
import useLoadingTimeout from '../../../global/components/helper-components/useComponents/useLoadingTimeout';
import { TbZoomInArea, TbZoomOutArea } from "react-icons/tb";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from 'swiper/modules';
import LaunchdeckSpinner from '../../../global/components/helper-components/components/LaunchdeckSpinner';
import 'swiper/scss';
import 'swiper/scss/pagination';


const DsrImageDisplay = ({ subWidgetContent }) => {
  const { loading, setLoading, setError } = useLoadingTimeout(5000);
  const [zoomedIndex, setZoomedIndex] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleZoomButtonClick = (index) => {
    setZoomedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleImageLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleImageError = () => {
    setLoading(false);
    setError(true);
  };

  useEffect(() => {
    document.body.style.overflow = zoomedIndex !== null ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [zoomedIndex]);

  const imgPlaceholder = (
    <Flex direction="column" alignItems="center" justifyContent="center" height="70px">
      <Box as={FaRegImages} width="70px" height="50px" mb="5px" />
      <p>Upload your images</p>
    </Flex>
  );

  const ImageZoomOverlay = ({ src, onClose }) => (
    <Portal>
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100vw"
        height="100vh"
        background="rgba(0,0,0,0.9)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        zIndex="1500"
      >

        <Flex justify='flex-start' align='flex-start' position='relative'>
          <Image src={src} alt="Zoomed" maxH="90vh" maxW="90vw" objectFit="contain" />
          <Box
            position='absolute'
            top='0em'
            right='-4em'
            bg='white'
            cursor='pointer'
            rounded='5px'
            p='10px'
            onClick={onClose}
          >
            <Box as={TbZoomOutArea} boxSize='1.2em' />
          </Box>
        </Flex>
      </Box>
    </Portal>
  );

  return (
    <Box my='1em' justifySelf={'center'} w='100%'>
      {zoomedIndex !== null && (
        <ImageZoomOverlay
          src={
            Array.isArray(subWidgetContent)
              ? subWidgetContent[zoomedIndex]?.url
              : subWidgetContent
          }
          onClose={() => setZoomedIndex(null)}
        />
      )}
      {Array.isArray(subWidgetContent) && subWidgetContent.length > 1 ? (
        <Swiper
          key={zoomedIndex}
          className='mySwiper'
          pagination={{
            dynamicBullets: true,
          }}
          modules={[Pagination]}
          style={{
            maxWidth: "100%",
            width: "100%"
          }}
        >

          {subWidgetContent.map((item, index) => {
            return (
              <SwiperSlide key={index} className="swiper-slide"
                style={{ width: "100%", maxWidth: "100%" }} // Adapts to parent container
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Box
                  key={index}
                  minH={loading && '18em'}
                  border={!loading && '1px solid'}
                  borderColor='gray.100'
                  rounded='0.25em'
                  position='relative'
                  display='inline-block'

                >
                  <img
                    src={item.url || item}
                    alt={`post-subwidget-${index}`}
                    draggable="false"
                    style={{
                      maxHeight: "400px", width: "auto", maxWidth: "100%", display: "block", margin: "0 auto",
                      objectFit: "contain", // Prevents stretching
                    }}
                  />
                </Box>

                {isHovered && (
                  <button
                    onClick={() => handleZoomButtonClick(index)}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      padding: '10px',
                      background: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    <Box as={TbZoomInArea} boxSize='1.2em' />
                  </button>
                )}
              </SwiperSlide>
            )
          })}
        </Swiper>
      ) : subWidgetContent ? (
        <Box
          border={loading ? "none" : '1px solid'}
          borderColor='gray.100'
          rounded='0.25em'
          w='100%'
          position='relative'
          display='inline-block'
          onMouseEnter={() => !loading && setIsHovered(true)}
          onMouseLeave={() => !loading && setIsHovered(false)}
        >
          {loading && (
            <Flex w='100%' h='100%' justify='center' align='center' minH='16em' bg='gray.50'>
              <LaunchdeckSpinner thickness='3px' boxSize='3em' />
            </Flex>
          )}
          <Image
            onLoad={handleImageLoad}
            onError={handleImageError}
            src={typeof subWidgetContent === 'string' ? subWidgetContent : subWidgetContent[0].url}
            alt="Sub-widget image"
            width="100%"
            rounded='0.25em'
            display={loading ? 'none' : 'block'}
          />
          {isHovered && (
            <Box
              onClick={() => handleZoomButtonClick(0)}
              cursor='pointer'
              rounded='0.25em'
              color='white'
              position= 'absolute'
              bg='rgba(0, 0, 0, 0.5)'
              p='10px'
              top='10px'
              right='10px'
            >
              <Box as={TbZoomInArea} boxSize='1.2em' />
            </Box>
          )}
        </Box>
      ) : (
        imgPlaceholder
      )}
    </Box>
  );
};

export default DsrImageDisplay;
